import { lightTheme } from "../styles/theme";

export const useStyledTheme = () => {
  return lightTheme;
};
